import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { ReactComponent as IconCard } from '../../assets/icons/richCheckout/generic-card.svg'
import { ReactComponent as FailedIcon } from '../../assets/icons/richCheckout/card-declined.svg'
import RoundButton from '../../components/RoundButton'

import styles from './PayWithCard.module.scss'

const PayWithCard = ({ cardHasFailed, onRetryCard, className }) => {
  const classNames = cn(styles.payWithCard, className)

  return (
    <div className={classNames}>
      <div className={styles.cardIcon}>
        {cardHasFailed ? <FailedIcon/> : <IconCard/>}
      </div>
      <div className={styles.headerText}>
        {cardHasFailed ? 'Declined' : 'Pay with Card'}
      </div>

      {cardHasFailed && (
        <>
          <div className={styles.instructionsText}>There was an issue processing your card.</div>
          <RoundButton text='Try Again' onClick={onRetryCard} className={styles.retryCardButton} />
        </>
      )}
      {!cardHasFailed && (
        <>
          <div className={styles.instructionsText}>All major credit cards accepted.</div>
          <div className={styles.instructionsText}>Please follow instructions on the card reader.</div>
        </>
      )}
    </div>
  )
}

PayWithCard.defaultProps = {
  cardHasFailed: false,
  onRetryCard: () => {},
}

PayWithCard.propTypes = {
  cardHasFailed: PropTypes.bool,
  onRetryCard: PropTypes.func,
}

export default PayWithCard
